import Text from '@components/Text/Text';
import {
  Checkbox as CheckboxMui,
  darken,
  FormControlLabel,
  styled,
} from '@mui/material';
import {
  Check,
} from '@mui/icons-material';

export const StyledContainer = styled(FormControlLabel)(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

export const StyledCheckboxRoot = styled(CheckboxMui, {
  shouldForwardProp: (prop) => prop !== 'error',
})<{ error: boolean }>(({ theme, error }) => ({
  '&.Mui-disabled .iconChecked': {
    backgroundColor: theme.palette.grey[500],
    border: `1px solid ${
      error ? theme.palette.error.main : theme.palette.grey[500]
    }`,
  },
  '&.Mui-disabled .iconUnchecked': {
    backgroundColor: darken(theme.palette.grey[100], 0.1),
    border: `1px solid ${
      error ? theme.palette.error.main : darken(theme.palette.grey[100], 0.15)
    }`,
  },
  '& .iconUnchecked': {
    backgroundColor: error ? theme.palette.error[100] : theme.palette.grey[100],
    border: `1px solid ${
      error ? theme.palette.error.main : theme.palette.grey[500]
    }`,
  },
}));

export const StyledIconChecked = styled(Check)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  width: '26px',
  height: '26px',
  borderRadius: '4px',
}));

export const StyledIconUnchecked = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[500]}`,
  backgroundColor: theme.palette.grey[100],
  width: '26px',
  height: '26px',
  borderRadius: '4px',
}));

export const LabelText = styled(Text)(({ theme }) => ({
  color: theme.palette.secondary[500],
}));
